Monitoring.Reports.Publications ||= {}

class Monitoring.Reports.Publications.TelcelAnalyticsView extends Backbone.View

  template: JST['backbone/templates/monitoring/reports/publication_analytics/telcel_analytics']

  events:
    'change #social-network-selector': 'onSocialNetworkChange'
    'click #export': 'download'
    'click #export-confirm': 'exportConfirm'

  initialize: (@options = {}) ->
    @ownFacebookPages = @_createSortedListOfHashes(@options.ownFacebookPages)
    @ownInstagramPages = @_createSortedListOfHashes(@options.ownInstagramPages)
    @ownTwitterPages = @_createSortedListOfHashes(@options.ownTwitterPages)
    @ownYoutubeAccounts = @_createSortedListOfHashes(@options.ownYoutubeAccounts)
    @ownLinkedinAccounts = @_createSortedListOfHashes(@options.ownLinkedinAccounts)
    @ownTiktokPostAccounts = @_createSortedListOfHashes(@options.ownTiktokPostAccounts)
    @ownTiktokAdAccounts = @_createSortedListOfHashes(@options.ownTiktokAdAccounts)
    @ownTiktokAdAccounts = @_createSortedListOfHashes(@options.ownTiktokAdAccounts)
    @initializeAccountOptions()
    @currentSocialNetwork = 'Facebook'
    @contentTags = @options.tags

  initializeAccountOptions:() =>
    @accounts = {}
    @accounts['Facebook'] = @ownFacebookPages
    @accounts['Twitter'] = @ownTwitterPages
    @accounts['Instagram'] = @ownInstagramPages
    @accounts['Youtube'] = @ownYoutubeAccounts
    @accounts['Linkedin'] = @ownLinkedinAccounts
    @accounts['TikTokPost'] = @ownTiktokPostAccounts
    @accounts['TikTokAd'] = @ownTiktokAdAccounts

  _createSortedListOfHashes: (accounts) =>
    accounts = _.uniq(accounts, (x) => (x.name).concat(x.id))
    list = _.collect(accounts, (account) => {id: account.id, name: account.name, label: account.name + " (" + account.id + ")"} )
    @_sortByName(list)

  filterOwnAccount:() =>
    activatedSocialNetworkValues = @_activatedSocialNetworkValue()
    @filterByAccountModes(@specialSelectableOptions()[activatedSocialNetworkValues].concat(@accounts[activatedSocialNetworkValues]))

  specialSelectableOptions: =>
    {
      'Instagram': @_allInstagramOwn()
      'Twitter': @_allTwitterOwn()
      'Facebook': @_allFacebookOwn()
      'Youtube': @_allYoutubeOwn(),
      'Linkedin': @_allLinkedinOwn(),
      'TikTokPost': @_allTikTokPostOwn(),
      'TikTokAd': @_allTikTokAdOwn()
    }

  _allInstagramOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_instagram_own')
    [name: name, label: name, id:'ALL_INSTAGRAM_OWN']

  _allTwitterOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_twitter_own')
    [name: name, label: name, id:'ALL_TWITTER_OWN']

  _allFacebookOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_facebook_own')
    [name: name, label: name, id:'ALL_FACEBOOK_OWN']

  _allYoutubeOwn:=>
    name = I18n.t('monitoring.publication_analytics_export.special_options.all_youtube_own')
    [name: name, label: name, id:'ALL_YOUTUBE_OWN']

  _allLinkedinOwn: =>
    name = 'Todas las cuentas propias de Linkedin'
    [name: name, label: name, id:'ALL_LINKEDIN_OWN']

  _allTikTokPostOwn: =>
    name = 'Todas las cuentas propias de TikTok'
    [name: name, label: name, id:'ALL_TIKTOK_POST_OWN']

  _allTikTokAdOwn: =>
    name = 'Todas las cuentas propias de TikTok Ads'
    [name: name, label: name, id:'ALL_TIKTOK_AD_OWN']

  filterByAccountModes: (filteredAccounts) =>
    @accountSelectionView.selectedOptions = @accountSelectionView.toObjectArray()
    @accountSelectionView.options = _.uniq(@accountSelectionView.toObjectArray().concat(filteredAccounts), (x) => x.name.concat(x.id))
    @$el.find('#filter-visible-by-statuses').html(@accountSelectionView.render().el)

  onSocialNetworkChange: (event) =>
    newSocialNetwork = $(event.currentTarget).val()
    selectedAccounts = @accountSelectionView.toArray()

    if (selectedAccounts.length == 0)
      @_updateAccountListFor(newSocialNetwork)
    else
      swal({
        title: I18n.t('monitoring.publication_analytics_export.social_network_change_confirmation'),
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        cancelButtonText: I18n.t('monitoring.publication_analytics_export.cancel_button'),
        confirmButtonText: I18n.t('monitoring.publication_analytics_export.confirm_button'),
        }, (isConfirm)=>
          if isConfirm
            @_updateAccountListFor(newSocialNetwork)
          else
            # Revert the select value
            @$el.find('#social-network-selector').val(@currentSocialNetwork).trigger('change.select2')
      )

  _updateAccountListFor: (socialNetwork) =>
    @currentSocialNetwork = socialNetwork
    @accountSelectionView.setLabelCustomClass(socialNetwork)
    accounts = @accounts[socialNetwork]
    accounts = @specialSelectableOptions()[socialNetwork].concat(accounts)
    @_changeAccountListTo(accounts)

  _changeAccountListTo: (accounts) =>
    @accountSelectionView.options = accounts
    @accountSelectionView.selectedOptions = []
    @$el.find('#filter-visible-by-statuses').html(@accountSelectionView.render().el)

  download: (event) =>
    @_showExportSpinner()
    event.preventDefault()
    @_proceedToStartExportationProcess()

  _proceedToStartExportationProcess: () =>
    @_startExportation(@_reportOptions(), I18n.t('monitoring.dashboard.actions.export.error'))



  _warnParametersError:(errorMessage) =>
    @_hideExportSpinner()
    swal
      title: errorMessage
      type: 'error'
      html: true

  _startExportation: (params, message) =>
    exportJob = new Monitoring.Methods.TelcelAnalyticsAsyncJob()
    exportJob.bind('completed', (results) => @_onComplete(results))
    exportJob.bind('failed', (results) => @_onFailure(message))
    exportJob.bind('show_error', (message) => @_warnParametersError(message))
    exportJob.bind('confirm_export', (results) => @_alertExportStart())
    exportJob.start(params)

  _onComplete: (results) =>
    window.open(results.path, '_blank');

  _onFailure: (message) =>
    window.showError(message)

  _showExportSpinner: =>
    this.$el.find('#export_spinner').show()

  _hideExportSpinner: =>
    this.$el.find('#export_spinner').hide()

  exportConfirm: =>
    @_alertSuccess()

  exportError: =>
    @_alertError()

  _alertSuccess: =>
    @_hideExportSpinner()

  _alertExportStart: =>
    @_hideExportSpinner()
    swal
      title: I18n.t 'customer.reports.modal.export_started_title'
      text: I18n.t 'customer.reports.modal.export_started_message'
      type: 'info'
      html: true

  _alertError: =>
    @_hideExportSpinner()
    swal
      title: I18n.t('monitoring.publication_analytics_export.export_error')
      type: 'error'
      html: true

  requestError: =>
    alert('We are sorry, but something went wrong. Please try again.')

  _activatedSocialNetworkValue: () =>
    @$el.find("#social-network-selector").val()

  _postStatisticValue: () =>
    @$el.find("#post-statistics button.active").attr('value') == 'active'

  _growthAndSumarizationValue: () =>
    @$el.find("#growth-sumarization button.active").attr('value') == 'active'

  _sortByName: (list) =>
    _.sortBy(list, (x) => x.name)

  _reportOptions: () ->
    from: this.$el.find('#from')[0].value
    content_creation_to: this.$el.find('#to')[0].value
    report_analysis_to: this.$el.find('#offset')[0].value
    timezone: @timezoneSelectorView.getSelectedTimeZone()
    social_network: @_activatedSocialNetworkValue()
    social_users: @_cleanSocialUsersObject(@_handleMultipleSelections(@accountSelectionView.toObjectArray()))
    tags: @tagSelectionView.getValues()
    report_components: @_reportAnalyticsOptions()

  _reportAnalyticsOptions: () =>
    {
      publication_analytics: @_postStatisticValue(),
      account_indicators: @_growthAndSumarizationValue()
    }

  render: ->
    @$el.html @template
      facebookCompetitorsPages: @facebookCompetitorsPages
      ownFacebookPages: @ownFacebookPages
      instagramCompetitorsPages: @instagramCompetitorsPages
      ownInstagramPages: @ownInstagramPages
      twitterCompetitorsPages: @twitterCompetitorsPages
      ownTwitterPages: @ownTwitterPages
      ownYoutubePages: @ownYoutubePages
    @_renderDatepickers()
    @_renderTimezoneSelector()
    @_renderSocialAccounts([], [])
    @_renderTags(@contentTags)
    @_initializeSelect2()
    this

  _initializeSelect2: ->
    formatOption = (state) ->
      return state.text unless state.id
      iconClass = $(state.element).data('icon')
      $('<span><i class="fa ' + iconClass + '"></i> ' + state.text + '</span>')

    $select = @$el.find('#social-network-selector')

    $select.select2
      templateResult: formatOption
      templateSelection: formatOption
      minimumResultsForSearch: Infinity

    $select.data('select2').$container.addClass('social-network-row__selector')

  _renderDatepickers: ->
    threeYearsAgo = new Date()
    threeYearsAgo.setFullYear(threeYearsAgo.getFullYear() - 3)
    @$el.find('.datepicker').datepicker
      todayBtn: 'linked'
      autoclose: true
      startDate: threeYearsAgo
    @$el.find('#from_metric').datepicker('update', moment().subtract('weeks', 1).toDate().format('DD-MM-YYYY'))
    @$el.find('#offset_metric').datepicker('update', new Date().format('DD-MM-YYYY'))
    @$el.find('#to_metric').datepicker('update', new Date().format('DD-MM-YYYY'))

  _renderTimezoneSelector: ->
    @timezoneSelectorView = new Monitoring.Views.TimeZoneSelectorView()
    @$el.find('#timezone_selector').html(@timezoneSelectorView.render().el)

  _renderSocialAccounts: (socialAccounts, selected)->
    text_placeholder = I18n.t 'monitoring.publication_analytics_export.select_account'
    @accountSelectionView = @_addSelectView(
      socialAccounts, 'id', 'label', selected,
      text_placeholder, '268px', true, '#filter-visible-by-statuses'
    )
    @accountSelectionView.setLabelCustomClass('facebook')
    inicialAccounts = @specialSelectableOptions()["Facebook"].concat(@ownFacebookPages)
    @_changeAccountListTo(inicialAccounts)

  _renderTags:(contentTags) ->
    @tagSelectionView = new Customer.Filters.ApeTagsFilterView({
      tagsByClientCode: contentTags
    })
    @$el.find('#tag-selector').html(@tagSelectionView.render().el)

  _handleMultipleSelections: (allSelected)->
    newSelectedOnlyWithIds = []
    _.each(allSelected, (selectedOption)=>
      if(@_isSpecial(selectedOption))
        specialOptionAccounts = _.collect(@_specialOptions()[selectedOption['id']], (x) => {id: x.id, name: x.name })
        newSelectedOnlyWithIds = newSelectedOnlyWithIds.concat(specialOptionAccounts)
      else
        newSelectedOnlyWithIds.push(selectedOption)
    )
    _.uniq(newSelectedOnlyWithIds, (x) => x.name.concat(x.id))

  _cleanSocialUsersObject: (socialUSers) ->
    _.collect(socialUSers, (x) => {id: x.id, name: x.name})

  _specialOptions:=>
    {
      'ALL_INSTAGRAM_OWN': @ownInstagramPages,
      'ALL_TWITTER_OWN':@ownTwitterPages,
      'ALL_FACEBOOK_OWN':@ownFacebookPages,
      'ALL_YOUTUBE_OWN': @ownYoutubeAccounts,
      'ALL_LINKEDIN_OWN': @ownLinkedinAccounts,
      'ALL_TIKTOK_POST_OWN': @ownTiktokPostAccounts,
      'ALL_TIKTOK_AD_OWN': @ownTiktokAdAccounts
    }

  _isSpecial:(option)=>
    specialOptions = Object.keys(@_specialOptions())
    specialOptions.indexOf(option['id']) >= 0

  _addSelectView: (options, valueProperty, descriptionProperty, selectedOptions, placeholder, width, editable , element) ->
    selectView = new App.APESelectView(
      options: options,
      valueProperty: valueProperty
      descriptionProperty: descriptionProperty
      selectedOptions: selectedOptions
      placeholder: placeholder
      width: width
      editable: editable
    )
    @$el.find(element).append(selectView.el)
    selectView
